export default __webpack_public_path__ + "static/media/KOD0061-min.c644bac6.webp";